module.exports = __webpack_public_path__ + "img/resort.939799b9.png";